import * as Yup from "yup";

import { TextManager } from "Components/TextContext";
import { Validation } from "Components/TextContext/commonComponentEnums";

export const phoneNumberSchema = (): Yup.StringSchema<string> => {
  const { getText } = TextManager;
  return Yup.string()
    .matches(
      /^((\+\d{2}\s?)?(\d{2}\s?){4})$|^((\+\d{2}\s?)?\d{3}\s?\d{2}\s?\d{3})$/,
      `${getText(Validation.PHONE_SIZE)}`,
    )
    .required(`${getText(Validation.PHONE_REQUIRED)}`);
};
